// TODO: (8/8/17, charis@careerplug.com) Change this hideous "index_dir" directory name once we switch
// to webpack and hopefully don't have 'index' directories and files conflict by having the same name

require("./edit")
require("./index_dir")

require("./job_create_modal.coffee")
